const statsTypes = {
  RESET_DAILY_CUSTOMER_INSIGHT_STATE: 'RESET_DAILY_CUSTOMER_INSIGHT_STATE',
  DAILY_CUSTOMER_INSIGHTS: {
    REQUEST: 'DAILY_CUSTOMER_INSIGHTS.REQUEST',
    SUCCESS: 'DAILY_CUSTOMER_INSIGHTS.SUCCESS',
    FAILURE: 'DAILY_CUSTOMER_INSIGHTS.FAILURE',
  },
};

export default statsTypes;
